module.exports = __webpack_public_path__ + "media/images/author/author-2-61940b601c9b24c678c013e20f0ad0bc.jpg";